<template>
<v-card>
  <v-list two-line class="py-0">
    <v-list-tile avatar @click="$emit('click',item)">
      <v-badge v-model="item.invisible" color="#CCCCCC99" left bottom overlap>
        <template v-slot:badge>
          <v-icon>visibility_off</v-icon>
        </template>
        <v-list-tile-avatar>
          <img :src="$FuncTypeIcons['56373']"></img>
        </v-list-tile-avatar>
      </v-badge>
      <v-list-tile-content>
        <v-list-tile-title class="brown--text">
          {{ item.title }}
        </v-list-tile-title>
        <v-list-tile-sub-title>{{ (userMacInfo[item.mac]||{}).hostname || item.mac }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'SceneItem',
  mixins: [UserAuth],
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/scene/SceneItem.vue